<div *ngIf="isGM || isDeveloper" 
     class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6 sticky top-16 z-10 (isScrolled ? 'shadow-md' : 'shadow-sm')">
  <div class="flex items-center justify-between">
    <div>
      <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
        Daily Updates
      </h2>
      <p class="mt-1 text-sm text-gray-500">
        Create and monitor daily questions for your technical team members
      </p>
    </div>
  </div>
</div>

<div *ngIf="isTech" 
     class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6 sticky top-16 z-10 (isScrolled ? 'shadow-md' : 'shadow-sm')">
  <div class="flex items-center justify-between">
    <div>
      <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
        Daily Technical Questions
      </h2>
      <p class="mt-1 text-sm text-gray-500">
        Review and respond to questions from your management team
      </p>
    </div>
  </div>
</div>
<lib-q></lib-q>
